import gql from 'graphql-tag';

export const createOrder = gql`
  mutation createOrder($items: [String!]!, $amount: Float!) {
    createOrder(order: { items: $items, amount: $amount }) {
      statusCode
      statusMessage
      orderId
      token
      transactionId
      merchantCode
      dni
      phone
      campus
    }
  }
`;
